import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { ROLE_LABELS } from "../lib/re";
import { toast } from "sonner";
import { Eye, Undo2 } from "lucide-react";

export function ViewAsBanner() {
  const { user, impersonating, stopViewAs } = useAuth();
  const navigate = useNavigate();
  if (!impersonating) return null;
  const back = async () => { await stopViewAs(); navigate("/painel"); toast.success("Voltou à conta de suporte"); };
  return (
    <div className="bg-amber-500/15 border-b border-amber-500/40 text-amber-200 text-sm px-4 sm:px-6 py-2 flex items-center justify-between gap-3" data-testid="view-as-banner">
      <span className="flex items-center gap-2"><Eye size={15} /> Modo suporte: a ver como <b>{user?.name}</b> ({ROLE_LABELS[user?.role] || user?.role})</span>
      <button onClick={back} data-testid="view-as-exit-btn" className="flex items-center gap-1 text-xs border border-amber-500/40 rounded-lg px-3 py-1 hover:bg-amber-500/20"><Undo2 size={13} /> Voltar ao suporte</button>
    </div>
  );
}

export function ViewAsSelector() {
  const { user, viewAs } = useAuth();
  const navigate = useNavigate();
  const [targets, setTargets] = useState([]);
  const [sel, setSel] = useState("");

  useEffect(() => {
    if (user?.role === "suporte") { api.get("/auth/view-as/targets").then((r) => setTargets(r.data)).catch(() => {}); }
  }, [user?.role]);

  if (user?.role !== "suporte") return null;
  const go = async () => {
    if (!sel) return;
    try { await viewAs(sel); navigate("/painel"); toast.success("Modo 'Ver como' ativo"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Não foi possível alternar"); }
  };
  const brokers = targets.filter((t) => t.role === "diretor");
  const consultants = targets.filter((t) => t.role === "consultor");
  return (
    <div className="flex items-center gap-2" data-testid="view-as-selector">
      <select className="input-almar py-1.5 text-xs w-44 sm:w-56" value={sel} onChange={(e) => setSel(e.target.value)} data-testid="view-as-select">
        <option value="">Ver como...</option>
        <optgroup label="Broker">{brokers.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}</optgroup>
        <optgroup label="Consultor">{consultants.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}</optgroup>
      </select>
      <button onClick={go} disabled={!sel} data-testid="view-as-go-btn" className="text-xs bg-[#C9A84C] text-[#0D1B2A] font-semibold rounded-lg px-3 py-1.5 disabled:opacity-40 flex items-center gap-1"><Eye size={13} /> Ver</button>
    </div>
  );
}
